import { smooth } from "./reveal";

// PROTOTYPE (hero shapes): the two breaths Costellazione tells its story in,
// and their pace. First the fill, 0 to 1, the disc turning gold as AVRAH
// reaches its clients (reveal.js); then the morph, 0 to 1, the circle going
// on into AVRAH's mark, its clients coming off it to draw it
// (transitionFrames.js). `pace` is how long the reveal plays and how it is
// eased (useReveal.js); `actsOf`, how far each breath has come at each
// point of it.
//
// The fill plays over FILL ms, eased. The disc then rests whole and gold
// for REST ms, so the two read as two breaths; then the morph plays over
// GATHER ms, at an even pace, as each client's flight eases itself.
const FILL = 2400;
const REST = 400;
const GATHER = 1300;
const MS = FILL + REST + GATHER;

const clamp01 = (value) => Math.min(1, Math.max(0, value));

export const BREATHS = {
  pace: { ms: MS, ease: (t) => t },
  actsOf: (reveal) => ({ fill: smooth(clamp01((reveal * MS) / FILL)), morph: clamp01((reveal * MS - FILL - REST) / GATHER) }),
};
